import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Icon, RowView2 } from "../style/common_style";

const MenuBox = styled.div`
  background-color: #2d2d2d;
  color: white;
  width: 15rem;
  min-height: 100%;
  overflow: hidden;
  div.Logo {
    padding: 2rem 1.5rem;
    cursor: pointer;
  }
`;
const Menu = styled(RowView2)`
  padding: 1rem 2rem;
  font-family: var(--font-Pretendard-SemiBold);
  white-space: nowrap;
  color: #8e8e8e;
  cursor: pointer;
  &:hover,
  &.this {
    color: white;
    img {
      filter: none;
    }
  }
  img {
    margin-right: 0.5rem;
    filter: invert(62%) sepia(8%) saturate(0%) hue-rotate(233deg)
      brightness(90%) contrast(84%);
  }
`;

interface AdminMenu {
  menuname: string;
}

const Admin_menubar = (props: AdminMenu) => {
  const Navigate = useNavigate();
  const menuname = props.menuname;

  const go_dashboard = () => Navigate("/admin/dashboard");
  const go_livelist = () => Navigate("/admin/livelist");
  const go_orderlist = () => Navigate("/admin/orderlist/non-pay");
  const go_userlist = () => Navigate("/admin/userlist/user");
  const go_setting = () => Navigate("/admin/setting");
  const go_coinmanage = () => Navigate("/admin/coinmanage");

  return (
    <MenuBox>
      <div className="Logo" onClick={go_dashboard}>
        <Icon
          style={{ height: 44 }}
          src={require("../../Image/Logo_Text.png")}
        />
      </div>

      <Menu
        className={menuname === "대시보드" ? "this" : ""}
        onClick={go_dashboard}
      >
        <Icon src={require("../../Image/Admin/ic_menu_board.png")} />
        대시보드
      </Menu>
      <Menu
        className={menuname === "라이브 목록" ? "this" : ""}
        onClick={go_livelist}
      >
        <Icon src={require("../../Image/Admin/ic_menu_live.png")} />
        라이브 목록
      </Menu>
      <Menu
        className={menuname === "주문내역" ? "this" : ""}
        onClick={go_orderlist}
      >
        <Icon src={require("../../Image/Admin/ic_menu_shopping.png")} />
        주문내역
      </Menu>
      <Menu
        className={menuname === "회원목록" ? "this" : ""}
        onClick={go_userlist}
      >
        <Icon src={require("../../Image/Admin/ic_menu_people.png")} />
        회원목록
      </Menu>
      <Menu
        className={menuname === "코인 관리" ? "this" : ""}
        onClick={go_coinmanage}
      >
        <Icon src={require("../../Image/Admin/ic_menu_coin.png")} />
        코인 관리
      </Menu>
      <Menu className={menuname === "설정" ? "this" : ""} onClick={go_setting}>
        <Icon src={require("../../Image/Admin/ic_menu_setting.png")} />
        설정
      </Menu>
    </MenuBox>
  );
};

export default Admin_menubar;
